import React, { useEffect, useRef, useState } from 'react';

import { Box } from '@chakra-ui/react';
import { Outlet, useLocation } from 'react-router-dom';

import ScrollToTop from '../../navigation/components/ScrollToTop';

const Layout = () => {
  const location = useLocation();

  const previousPathname = useRef(location.pathname);

  const [animatePage, setAnimatePage] = useState(true);

  useEffect(() => {
    const pathnameChanged =
      previousPathname.current !== location.pathname;

    if (pathnameChanged) {
      previousPathname.current = location.pathname;
      setAnimatePage(true);
    }

    const timeout = window.setTimeout(() => {
      setAnimatePage(false);
    }, 600);

    return () => {
      window.clearTimeout(timeout);
    };
  }, [location.pathname]);

  return (
    <>
      <Box
        width="100%"
        minHeight="100vh"
        backgroundColor="white"
        animation={
          animatePage
            ? 'pageFadeIn 0.6s ease-in-out both'
            : 'none'
        }
        sx={{
          '@keyframes pageFadeIn': {
            '0%': {
              opacity: 0,
            },
            '100%': {
              opacity: 1,
            },
          },
        }}
      >
        <Outlet />
      </Box>

      <ScrollToTop />
    </>
  );
};

export default Layout;